/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/validateTwoFactor.scss';

import {ChangeFunction, ErrorType, Loader, WithBackground} from '@dvrd/dvr-controls';
import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler} from 'react';
import {BolmateButton, BolmateNumberInput} from "../../controls";

interface Props {
    onChange: ChangeFunction;
    onFocus: FocusEventHandler;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onClose: MouseEventHandler;
    token: string;
    active: boolean;
    loading: boolean;
    error: ErrorType;
    explanation?: string;
}

export default function ValidateTwoFactor(props: Props) {
    const {active, onClose, error, loading, onFocus, token, onSubmit, onChange, explanation} = props;
    const explanationText = explanation ?? 'Vul hieronder de tweestapsverificatie code in.';
    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='validate-two-factor'>
                <div className='header-container'>
                    <label className='header-title'>Tweestapsverificatie</label>
                </div>
                <div className='body-container'>
                    <Loader active={loading}/>
                    <label>{explanationText}<br/><br/>Deze code wordt gegenereerd door een app op uw telefoon (meestal
                        Google Authenticator).</label>
                    <BolmateNumberInput onChange={onChange} value={token} error={error} onFocus={onFocus}
                                        onEnter={onSubmit} label='Code'
                                        inputProps={{autoComplete: 'one-time-code', inputMode: 'numeric'}}
                                        autoFocus wholeNumbers disableSymbols/>
                </div>
                <div className='footer-container'>
                    <BolmateButton onClick={onSubmit} label='Oké' disabled={loading || token.length !== 6}/>
                </div>
            </div>
        </WithBackground>
    )
}